<template>
    <div class="w-full" v-if="message">
        <vs-alert active="true" :color="variant" class="text-center">
            {{message}}
        </vs-alert>
    </div>
</template>
<script>
    export default {
        name: 'ResponseAlert',
        data() {
            return {
                variant: '',
                message: ''
            }
        },
        methods: {
            setResponse(error, variant){
                const {code, data, message} = error
                if(code === 422){
                    this.message = data.map(({message}) => message.replace(/"|\//gi, '')).join(", ")
                } else {
                    this.message = message
                }
                this.variant = variant;
                // window.scrollTo(0,0);
                setTimeout(() => this.message='', 10000);
            },
            setResponseCustom(error, variant){
                this.message = error;
                this.variant = variant;
                window.scrollTo(0,0);
                setTimeout(() => this.message='', 10000);
            },
        },
    };
</script>
